<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Update segment?"
        :error="error"
        @close="$emit('close')"
    >
        <template #body>
            <div>
                <label
                    for="update-segment-name"
                    class="block text-sm lg:text-base font-medium text-taupe-800"
                    >Segment name</label
                >
                <div class="mt-1">
                    <input
                        type="text"
                        name="update-segment-name"
                        id="update-segment-name"
                        :value="name"
                        @input="$emit('update:name', $event.target.value)"
                        class="block w-full rounded-md border-taupe-300 shadow-xs focus:border-taupe-500 focus:ring-taupe-500 sm:text-sm lg:text-base"
                    />
                </div>
            </div>
        </template>
        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
            <zen-button type="submit" @click="$emit('confirm')">
                Save
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'UpdateSegmentSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        name: {
            type: String,
            default: null,
        },
        error: {
            type: [String, Object],
            default: null,
        },
    },
    emits: ['close', 'confirm', 'update:name'],
}
</script>
